module.exports = __webpack_public_path__ + "img/card-dual-img.67478769.png";